import React, { useState } from "react";
import PropTypes from "prop-types";
import { makeStyles } from "@material-ui/core/styles";
import Grid from "@material-ui/core/Grid";
import Collapse from "@material-ui/core/Collapse";

import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import eightAxios from "configs/axiosConfig";
import AudioPlayer from "../../AudioPlayer";
import { useTranslation } from "react-i18next";

const useStyles = makeStyles((theme) => ({
  labelSpan: {
    fontWeight: "500",
  },
  valueSpan: {
    width: "100%",
    textTransform: "uppercase",
  },
  button: {
    width: "100px",
    textTransform: "capitalize",
  },
  nameSpan: {
    fontWeight: "bold",
    color: theme.palette.primary.main,
    "&:hover": {
      cursor: "pointer",
    },
  },
}));

const AudioPlayerField = (props) => {
  const { t } = useTranslation();
  const { label, value } = props;
  const [showPlayer, setShowPlayer] = useState(false);
  const [audioUrl, setAudioUrl] = useState(null);
  const classes = useStyles();

  const togglePlayer = () => {
    const originalUrl = process.env.REACT_APP_API_URL + "v1/"
    const newUrl = originalUrl.startsWith("https://")
      ? originalUrl.replace("https://", "http://")
      : originalUrl;
    const trimmedValue = value.replace(newUrl, '') 
    if (!showPlayer) {
      if (!audioUrl) {
        eightAxios
          .get(trimmedValue)
          .then((response) => {
            setAudioUrl(response.data.audio);
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => {
            setShowPlayer(true);
          });
      } else {
        setShowPlayer(true);
      }
    } else {
      setShowPlayer(false);
    }
  };

  return (
    <Grid container item lg={12} direction="column">
      <Grid item lg={12}>
        <span className={classes.labelSpan}>{label}</span>
      </Grid>
      <Grid item>
        <span
          className={classes.nameSpan}
          style={{
            display: "flex",
          }}
          onClick={togglePlayer}
        >
          {t("Show Audio Player")}{" "}
          {showPlayer ? <ExpandLessIcon /> : <ExpandMoreIcon />}
        </span>
        <Collapse in={showPlayer} unmountOnExit>
          <Grid item lg={12}>
            {audioUrl ? <AudioPlayer audioSrc={audioUrl} /> : "Loading"}
          </Grid>
        </Collapse>
      </Grid>
    </Grid>
  );
};

AudioPlayerField.propTypes = {
  label: PropTypes.string,
  value: PropTypes.string,
};

export default AudioPlayerField;
